import { Button } from "@/components/ui/button";
import { useAuth } from "@/contexts/AuthContext";

// Inline Google "G" logo
function GoogleIcon() {
  return (
    <svg width="18" height="18" viewBox="0 0 48 48" aria-hidden="true">
      <path fill="#FFC107" d="M43.6 20.5H42V20H24v8h11.3c-1.6 4.6-6 8-11.3 8-6.6 0-12-5.4-12-12s5.4-12 12-12c3 0 5.8 1.1 7.9 3l5.7-5.7C34 5.1 29.3 3 24 3 12.4 3 3 12.4 3 24s9.4 21 21 21 21-9.4 21-21c0-1.2-.1-2.3-.4-3.5z"/>
      <path fill="#FF3D00" d="M6.3 14.7l6.6 4.8C14.7 16 19 13 24 13c3 0 5.8 1.1 7.9 3l5.7-5.7C34 5.1 29.3 3 24 3 16 3 9.1 7.6 6.3 14.7z"/>
      <path fill="#4CAF50" d="M24 45c5.2 0 9.9-2 13.5-5.2l-6.2-5.3C29.2 36 26.7 37 24 37c-5.3 0-9.7-3.4-11.3-8L6 33.6C8.8 40.6 15.8 45 24 45z"/>
      <path fill="#1976D2" d="M43.6 20.5H42V20H24v8h11.3c-.8 2.3-2.2 4.2-4 5.5l6.2 5.3c-.4.4 6.5-4.8 6.5-14.8 0-1.2-.1-2.3-.4-3.5z"/>
    </svg>
  );
}

export default function GoogleAuthButton({ label = "Continue with Google", testId = "google-auth-btn" }) {
  const { startGoogleLogin } = useAuth();
  return (
    <Button
      type="button"
      onClick={startGoogleLogin}
      variant="outline"
      className="w-full rounded-full h-11 gap-2 border-border hover:bg-secondary"
      data-testid={testId}
    >
      <GoogleIcon />
      <span className="font-medium">{label}</span>
    </Button>
  );
}
